declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    twitter: {
      /**
       * Add an image
       */

      insertTwitter: (url?: string, className?: string) => ReturnType
    }
  }
}

import { Node, PasteRule, markPasteRule, mergeAttributes } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import TwitterEmbed from './TwitterEmbed.js'

export const Twitter = Node.create({
  name: 'twitter',

  group: 'block',
  content: 'inline*',
  draggable: true,

  // content: 'inline*',

  parseHTML() {
    return [
      {
        tag: 'div[data-type="twitter"]',
      },
    ]
  },

  addAttributes() {
    return {
      url: { default: null },
      src: { default: null },
      class: { default: null },
    }
  },

  addKeyboardShortcuts() {
    return {
      'Mod-Enter': () => {
        return this.editor
          .chain()
          .insertContentAt(this.editor.state.selection.head, {
            type: this.type.name,
          })
          .focus()
          .run()
      },
    }
  },

  // renderHTML({ HTMLAttributes }) {
  //   return [
  //     "div",
  //     mergeAttributes(HTMLAttributes, { "data-type": "twitter" }),
  //     0,
  //   ];
  // },
  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-type": "twitter",
        class: `react-renderer node-twitter ${HTMLAttributes.class ?? ""}`,
      }), [
        'div',
        mergeAttributes(
          { class: 'socialMediaContainer' },
        ),
        ['div', mergeAttributes({ class: 'rsme-embed rsme-twitter-embed', style: 'overflow: hidden; width: 325px; border-radius: 12px;' }),

          [
            'blockquote',
            { class: 'twitter-tweet' },
            ['a', { href: convertYoutubeUrlToEmbed(HTMLAttributes.url) ?? HTMLAttributes.src }, ''],
          ],
          [
            'script',
            {
              async: true,
              src: 'https://platform.twitter.com/widgets.js',
              charset: 'utf-8',
            },
          ],
        ]
      ]
    ]
  },

  addNodeView() {
    return ReactNodeViewRenderer(TwitterEmbed)
  },

  addCommands() {
    return {
      insertTwitter:
        (url, className) =>
          ({ commands, state }) => {
            let formattedUrl = url
            if (url) {

              formattedUrl = convertYoutubeUrlToEmbed(url)
            }
            return commands.insertContent({
              type: 'twitter',
              attrs: {
                url: url,
                class: className,
                src: formattedUrl,
              },
            })
          },
    }
  },
})

function convertYoutubeUrlToEmbed(url: string): string | undefined {
  if (!url) return undefined;
  try {
    let formattedUrl
    const tweetMatch = url.match(/(?:twitter\.com|x\.com)\/([^\/]+)\/status\/(\d+)/)
    if (tweetMatch) {
      const [_, username, tweetId] = tweetMatch
      formattedUrl = `https://twitter.com/${username}/status/${tweetId}`
    }
    return formattedUrl ? formattedUrl : undefined;
  } catch {
    return undefined;
  }
}
function isValidHttpUrl(string: string) {
  let url

  try {
    url = new URL(string)
  } catch (_) {
    return false
  }

  return url.protocol === 'http:' || url.protocol === 'https:'
}
